/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FanRemixContestEndedNotificationActionData } from './FanRemixContestEndedNotificationActionData';
import {
    FanRemixContestEndedNotificationActionDataFromJSON,
    FanRemixContestEndedNotificationActionDataFromJSONTyped,
    FanRemixContestEndedNotificationActionDataToJSON,
} from './FanRemixContestEndedNotificationActionData';

/**
 * 
 * @export
 * @interface FanRemixContestEndedNotificationAction
 */
export interface FanRemixContestEndedNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof FanRemixContestEndedNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof FanRemixContestEndedNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof FanRemixContestEndedNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {FanRemixContestEndedNotificationActionData}
     * @memberof FanRemixContestEndedNotificationAction
     */
    data: FanRemixContestEndedNotificationActionData;
}

/**
 * Check if a given object implements the FanRemixContestEndedNotificationAction interface.
 */
export function instanceOfFanRemixContestEndedNotificationAction(value: object): value is FanRemixContestEndedNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function FanRemixContestEndedNotificationActionFromJSON(json: any): FanRemixContestEndedNotificationAction {
    return FanRemixContestEndedNotificationActionFromJSONTyped(json, false);
}

export function FanRemixContestEndedNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): FanRemixContestEndedNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': FanRemixContestEndedNotificationActionDataFromJSON(json['data']),
    };
}

export function FanRemixContestEndedNotificationActionToJSON(value?: FanRemixContestEndedNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': FanRemixContestEndedNotificationActionDataToJSON(value.data),
    };
}

